import React from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk/format';
import { ref } from '@dbk-legacy/muster/utils';

import sumBy from 'lodash/sumBy';

import Text, { H3 } from '../../../components/common/text';
import NavigationArrow from '../../../components/common/navigation-arrow';

import styles from './empty-state.styles';

function EmptyState({ maturities }) {
  const {
    selectedTab: {
      periodType,
    periodNo,
    },
    otherPeriodAssets,
  } = maturities;

  const otherMaturitiesCount = sumBy(otherPeriodAssets, 'maturityCount');
  const isCustomPeriod = periodType === 'custom';

  return (
    <View testID="empty-state" style={[
      styles.root,
      isCustomPeriod && styles.rootCustom,
    ]}>
      <H3 testID="title" style={[
        styles.title,
        isCustomPeriod && styles.titleCustom,
      ]}>
        <FormattedMessage
          id={`app.maturities.overview.emptyState.title.${periodType}`}
          values={{ n: periodNo }}
        />
      </H3>

      {( !isCustomPeriod && periodType != "months" ) &&
        <Text testID="other-periods-text" style={styles.otherPeriodsText}>
          <FormattedMessage
            id="app.maturities.overview.emptyState.otherPeriodsText"
            values={{
              otherMaturities: otherMaturitiesCount,
              otherPeriods: otherPeriodAssets.length,
            }}
          />
        </Text>
      }

      {!isCustomPeriod && otherPeriodAssets.length > 0 &&
        <View testID="other-periods-list" style={styles.otherPeriodsList}>
          {otherPeriodAssets.map(item => (
            <TouchableOpacity key={item.periodType} onPress={() => item.onSelect(item)}>
              <View testID="other-period" style={styles.otherPeriod}>
                <Text style={styles.otherPeriodBullet}>•</Text>
                <Text style={styles.otherPeriodText}>
                  <FormattedMessage
                    id={`app.maturities.overview.emptyState.otherPeriod.${item.periodType}`}
                    values={{
                      maturities: item.periodType == "months" ? otherMaturitiesCount : item.maturityCount,
                      n: item.periodNo,
                    }}
                  />
                </Text>
                <View style={styles.otherPeriodArrow}>
                  <NavigationArrow size="normal" />
                </View>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      }
    </View>
  );
}

EmptyState.propTypes = {
  maturities: PropTypes.object,
};

export default createContainer({
  $fragments: {
    maturities: {
      selectedTab: {
        periodType: true,
        periodNo: true,
      },
      otherPeriodAssets: {
        $type: 'list',
        $range: {
          offset: 0,
          length: ref('maturities.otherPeriodAssets.length'),
        },
        $node: {
          maturityCount: true,
          periodType: true,
          periodNo: true,
          onSelect: { $call: 'onSelect' },
        },
      },
    },
  },
})(EmptyState);
